import * as dateFns from "date-fns";
import { nl } from "date-fns/locale";

window["date-fns"] = dateFns;
window["date-fns"].locale = { nl };

export { dateFns };
